import { useEffect, useState } from 'react';

// styles defined in assets/globalStyles.css

interface LoadingSpinnerProps {
  scale?: number;
  height?: number | string;
  white?: boolean;
  delayMs?: number;
}

const LoadingSpinner = ({
  scale = 0.1,
  height = 240,
  white = false,
  delayMs = 200,
}: LoadingSpinnerProps) => {
  const isVisible = useDelayedVisibility(delayMs);

  if (!isVisible) {
    return (
      <div className='loader-container' style={{ height }} aria-hidden='true' />
    );
  }

  return (
    <div
      className='loader-container'
      style={{
        transform: `scale(${scale})`,
        height,
      }}
    >
      <svg
        viewBox='0 0 78 68'
        xmlns='http://www.w3.org/2000/svg'
        aria-hidden='true'
      >
        <circle
          cx='39'
          cy='34'
          r='18'
          fill='none'
          stroke={white ? 'white' : `currentColor`}
          strokeWidth={7}
          strokeLinecap='round'
          strokeDasharray='120'
          strokeDashoffset='30'
        >
          <animateTransform
            attributeName='transform'
            type='rotate'
            from='0 39 34'
            to='360 39 34'
            dur='1.4s'
            repeatCount='indefinite'
          />
        </circle>

        {/* Inner icon */}
        <g fill={white ? 'white' : `currentColor`}>
          <path
            d='M41.3,25.98c-0.11,0.11-0.21,0.2-0.3,0.3c-0.09,0.1-0.18,0.2-0.26,0.31
          c-0.09,0.12-0.17,0.24-0.24,0.36c-0.07,0.12-0.13,0.24-0.19,0.36
          c-0.06,0.12-0.11,0.25-0.15,0.38c-0.04,0.13-0.08,0.26-0.1,0.4
          c-0.03,0.13-0.04,0.27-0.06,0.41c-0.01,0.14-0.02,0.29-0.02,0.43
          c0,0.14,0.02,0.27,0.03,0.41c0.02,0.14,0.05,0.27,0.08,0.4
          c0.03,0.13,0.07,0.26,0.12,0.39c0.05,0.13,0.1,0.25,0.16,0.38
          c0.06,0.13,0.14,0.26,0.21,0.38c0.07,0.11,0.16,0.23,0.24,0.33
          c0.09,0.11,0.18,0.21,0.28,0.3
          c0.75,0.72,1.64,1.08,2.68,1.07
          c1.04-0.01,1.92-0.42,2.64-1.14
          c0.17,0.67,0.25,1.34,0.25,2.03
          c0,3.38-2.1,6.39-5.22,7.59
          c-0.95,0.37-1.94,0.54-2.97,0.54
          c-3.62-0.01-6.8-2.44-7.79-5.89
          c-0.28-0.97-0.37-1.96-0.29-2.96
          c0.32-3.58,2.86-6.34,6.02-7.17
          c0.72-0.19,1.45-0.28,2.19-0.27
          c0.81,0.01,1.61,0.13,2.38,0.38z'
          />
        </g>
      </svg>
    </div>
  );
};

function useDelayedVisibility(delayMs = 200) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timeoutId = setTimeout(() => setIsVisible(true), delayMs);
    return () => clearTimeout(timeoutId);
  }, [delayMs]);

  return isVisible;
}

export default LoadingSpinner;
